
import { defineComponent, computed, onMounted } from "vue";
import moment from "moment";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import NewCardModal from "@/components/modals/forms/NewCardModal.vue";

export default defineComponent({
  name: "kt-payment-method",
  components: {
    NewCardModal,
  },
  props: ["user"],
  setup(props, { emit }) {
    const store = useStore();
    const cardStringConstructor = (card) => {
      const tempCard = card?.data?.[0]?.card ?? {};
      return `${tempCard?.brand ?? ""} ending in ${tempCard?.last4 ?? ""}`;
    };
    const convertDate = (date) => {
      return moment(date).format("MMM YYYY");
    };
    const cards = computed(() => store.getters.cardsGetter);
    const getCards = async () => {
      try {
        const response = await store.dispatch(Actions.GET_CARDS);
        console.log({ response });
        if (cards.value?.length && props.user?.userPlan?.status == 2) {
          emit("subscribe", true);
        }
      } catch (err) {
        //
      }
    };
    const changeActiveCard = async (isActive, id) => {
      try {
        const response = await store.dispatch(
          Actions.CHANGE_ACTIVE_CARD_STATUS,
          {
            cardId: id,
            status: isActive == 1 ? 0 : 1,
          }
        );
        if (!response?.success) throw new Error("error in active card status");
        getCards();
        for (let i = 0; i < +cards.value.length; i++) {
          if (cards.value[i]?.id != id) {
            await store.dispatch(Actions.CHANGE_ACTIVE_CARD_STATUS, {
              cardId: cards.value[i]?.id,
              status: 0,
            });
          }
        }
        getCards();
      } catch (err) {
        //
      }
    };
    return {
      changeActiveCard,
      cards,
      cardStringConstructor,
      convertDate,
    };
  },
});
